import React, { type JSX } from "react";

import {
    type BoxComponentWithDefault,
    boxForwardRef,
} from "../../../../helpers/common/Box/Box";
import { Dropdown } from "../../../Dropdown";
import { DROPDOWN_DISPLAY_NAME } from "../../../Dropdown/utils/core";

import type { IDropdownItem } from "../../../Dropdown/components/Item/DropdownItem";

export const SearchMenuItem = boxForwardRef<
    BoxComponentWithDefault<"button", IDropdownItem>
>(({ children, "data-tsid": tsid, ...props }, ref): JSX.Element => {
    return (
        <Dropdown.Item data-tsid={tsid} {...props} ref={ref}>
            {children}
        </Dropdown.Item>
    );
});

SearchMenuItem.displayName = `${DROPDOWN_DISPLAY_NAME}.Item`;

export default SearchMenuItem;
